export default __webpack_public_path__ + "static/media/mask-picture.3e889cfd.png";